import React from "react";
import Router from "../router/Router";
import Header from "./Header/Header";

export default function Layout({ children }) {
  return (
    <>
      <div className="bg-white  flex flex-col">
        <Header />
        <div>{children}</div>
      </div>
    </>
  );
}
